import { call, put, takeLatest } from "@redux-saga/core/effects";

import { DetailsTableApi } from "./DetailsTableApi";
import { DetailsTableconstant } from "./DetailsTableConstant";

function* getDetailstable(payload) {
  
    try {
        yield put({ type: DetailsTableconstant.DETAILS_TABLE_REQUEST });


        const res = yield call(DetailsTableApi.getDetailsTable,payload);

    
        yield put({
            type: DetailsTableconstant.DETAILS_TABLE_RESPONSE,
            payload: res,
        });
    } catch (e) {
        console.log('Error', e);
        yield put({
            type: DetailsTableconstant.DETAILS_TABLE_RESPONSE,
            payload: [],
        });
    }
};

export function* registerDetailstableSaga() {
    yield takeLatest(DetailsTableconstant.DETAILS_TABLE_SAGA,getDetailstable);
}
